export const XReportTitles = [
    'Payment Type',
    'Accepter Count',
];

export const StepsList = {
    firstStep: 'firstStep',
    secondStep: 'secondStep',
};

export const StepsTitle = {
    [StepsList.firstStep]: 'Confirm you have collected the money',
    [StepsList.secondStep]: 'Are you done with Cash Collection?',
};
